/**
 * Sumar pentru widget-ul „Ultimele oferte" din dashboard.
 * Reflectă structura reală: o ofertă conține mai multe elemente (navlu/locale/auto)
 * cu preț unic sau array pe tip de container.
 */
export interface LatestOfferRow {
  id: number;
  type: string;
  status: string;
  companyName: string;
  companyId: number;
  terminal: string | null;
  /** ISO string sau null. */
  validityStartDate: string | null;
  /** ISO string sau null. */
  validityEndDate: string | null;
  containerTypes: string[];
  elementsTotal: number;
  navluCount: number;
  localeCount: number;
  autoCount: number;
  priceMin: number | null;
  priceMax: number | null;
  shippingCurrency: string | null;
  /** Rute distincte din offerElements, ex. "CNSHA → ROCND". */
  routes: string[];
}

export const EMPTY_LATEST_OFFERS: LatestOfferRow[] = [];
